import * as React from 'react';
import Grid from '../../components/controls/grid/Grid';
import Section from '../../components/controls/grid/Section';
import Row from '../../components/controls/grid/Row';
import Text from '../../components/controls/Text';
import ComboBox from '../../components/controls/ComboBox';
import { useLeapData } from '../../hooks/useLeapData';
import { useLeapState } from '../../hooks/useLeapState';
import MultiBox from '../../components/controls/MultiBox';

type Props = { state: any, controller: any }

export default (props: Props) => {
    const page = useLeapState(props.controller, false)

    const name = useLeapData("name", "nome permesso", page)
    const privilege = useLeapData("privilegesID", "privilegio", page, "privileges")
    const role = useLeapData("role", "ruolo", page, "roles")

    return (
        <>
            <Grid>
                <Section>
                    <Row>
                        <MultiBox {...privilege} className="ms-sm12" required titleType="text" />
                    </Row>
                    <Row>
                        <ComboBox {...role} className="ms-sm12" required />
                    </Row>
                    <Row>
                        <Text {...name} className="ms-sm12" required maxlength={50} />
                    </Row>
                </Section>
            </Grid>
        </>
    );
}
